import React from 'react';
import CommonPageComponent from './ui/CommonPageComponent';
import { drapcodeIcon } from './custom/icon-library';
const PermissionDenied = ({ message = 'this feature' }) => {
  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <div className="card">
        <div className="card-header card-header-icon" data-background-color="drapcode-violet">
          <i className={`wb ${drapcodeIcon('warning')}`}></i>
        </div>
        <div className="card-content">
          <div className="card-title-header">
            <h4 className="card-title">Upgrade Your Plan</h4>
            <div className="card-cta"></div>
          </div>
          <strong>
            To use {message}, please upgrade your plan. &nbsp;
            <a
              href={`${process.env.REACT_APP_ORGANIZATION}accounts`}
              className="btn btn-sm btn-theme-submit"
            >
              <i className="wb webconnect-paper-plane-fill"></i> upgrade
            </a>
          </strong>
          &nbsp;
        </div>
      </div>
    </div>
  );
};

export default PermissionDenied;
